module.exports = __webpack_public_path__ + "static/img/v-s-one.2b71b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-six/v-s-one.png
// module id = qJj0
// module chunks = 0